import { render, staticRenderFns } from "./GlobalBottom.vue?vue&type=template&id=79703f50&scoped=true"
import script from "./GlobalBottom.vue?vue&type=script&lang=js"
export * from "./GlobalBottom.vue?vue&type=script&lang=js"
import style0 from "./GlobalBottom.vue?vue&type=style&index=0&id=79703f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79703f50",
  null
  
)

export default component.exports